import React from 'react'
import { Avatar, Stack, Typography } from '@mui/material'
import { poolwerxColors } from '../../theme/colors'
import { getProfileImageUrl, getUserInitials } from '../../utils/profileImage'
import { logout } from '../../services/auth'

interface AuthPageFooterProps {
  user: {
    name?: string
    email?: string
    picture?: string | null
  }
}

const AuthPageFooter: React.FC<AuthPageFooterProps> = ({ user }) => {
  return (
    <Stack alignItems="center" spacing={1} sx={{ pt: 2, borderTop: '1px solid #e0e0e0' }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Avatar
          src={getProfileImageUrl(user) || undefined}
          sx={{ width: 24, height: 24, bgcolor: poolwerxColors.teal, fontSize: '0.7rem' }}
        >
          {getUserInitials(user)}
        </Avatar>
        <Typography variant="caption" color="textSecondary">
          {user.name} &middot; {user.email}
          <span style={{ margin: '0 4px' }}>&middot;</span>
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); logout() }}
            style={{ color: poolwerxColors.teal, textDecoration: 'underline' }}
          >
            Sign out
          </a>
        </Typography>
      </Stack>
      <Typography variant="caption" color="textSecondary">
        Need help?
        <a
          href="https://poolwerx.freshdesk.com/a/tickets/new"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: poolwerxColors.teal, textDecoration: 'underline', marginLeft: '4px' }}
        >
          Submit a support ticket
        </a>
      </Typography>
    </Stack>
  )
}

export default AuthPageFooter
